module.exports = __webpack_public_path__ + "img/the-netherlands-leukaemia-male.7134e01c.png";